import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import "./DiscountedPriceSection.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const DiscountedPriceSection = ({
	percentage = 0,
	net = 0,
	discounted = 0,
	typographySize,
	isBold = true,
	shouldDisplaySuffix = true,
}) => {
	if (discounted === 0) {
		return null;
	}

	const amountClassName = classNames({
		"amount--regular": !isBold,
	});

	return (
		<div className="discounted-price-section">
			{percentage !== 0 && (
				<Typography
					className="discounted-price-section__discount-percentage"
					data-testid="discount-percentage"
					variant={TYPOGRAPHY_VARIANTS.SMALL}
					component="p"
				>
					<p>-{percentage} %</p>
				</Typography>
			)}
			{discounted !== net && (
				<Typography
					className="discounted-price-section__initial-price"
					variant={TYPOGRAPHY_VARIANTS.SMALL}
					component="p"
				>
					<AmountContainer amount={net} className={amountClassName} />
				</Typography>
			)}
			<Typography
				className="discounted-price-section__final-price"
				variant={typographySize}
				isBold={isBold}
				component="p"
			>
				<AmountContainer amount={discounted} className={amountClassName} />
				{shouldDisplaySuffix && (
					<Typography
						variant={TYPOGRAPHY_VARIANTS.SMALL}
						component="span"
						isBold={isBold}
					>
						/<FormattedMessage id={"general.night.label"} />
					</Typography>
				)}
			</Typography>
		</div>
	);
};

DiscountedPriceSection.propTypes = {
	typographySize: PropTypes.string,
	isBold: PropTypes.bool,
	shouldDisplaySuffix: PropTypes.bool,
	percentage: PropTypes.number,
	net: PropTypes.number,
	discounted: PropTypes.number,
};

export default memo(DiscountedPriceSection);
